import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type TGiftCard = {
    cardNumber: string;
};

type Props = {
    giftCardList: Array<TGiftCard>;
    onDelete: (cardCode: string) => Promise<void>;
};

const GiftCardList = ({ giftCardList, onDelete }: Props) => {
    const { t } = useGranite();

    if (!giftCardList || giftCardList.length === 0) {
        return null;
    }

    const onDeleteHandler = async (giftCardCode: string) => {
        if (onDelete) {
            await onDelete(giftCardCode);
        }
    };

    return (
        <>
            <h4>{t("checkout.paymentMethods.giftCard.list.title")}</h4>
            <p>{t("checkout.paymentMethods.giftCard.list.text")}</p>
            <ul>
                {giftCardList.map((giftCard, index) => (
                    <li
                        className="py-1"
                        key={index}
                    >
                        <span className="pr-1">{giftCard.cardNumber}</span>
                        <button
                            type={"button"}
                            className="btn btn-link p-0 align-baseline"
                        >
                            <i
                                className="las la-trash-alt la-lg"
                                onClick={() =>
                                    onDeleteHandler(giftCard.cardNumber)
                                }
                            />
                        </button>
                    </li>
                ))}
            </ul>
        </>
    );
};

export default GiftCardList;
